module.exports = __webpack_public_path__ + "media/images/logo_large-a660227f217575f36b80db14404f4e88.png";